import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { Router } from "@angular/router";
import ReportSpam from "../../../models/report-spam.model";

import Comment from "../../../models/comment.model";
import { CommentService } from "../../../services/comment.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-view-comment",
  styleUrls: ["./view-comment.component.scss"],
  templateUrl: "./view-comment.component.html",
})
export class ViewCommentComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() comment: Comment;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";

  constructor(
    public userService: UserService,
    private commentService: CommentService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    this.isMore = value;
  }

  navigateRef(item) {
    if (item.navigateUrl && item.navigateUrl.length > 0) {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  report(item: ReportSpam) {
    this.onDelete.emit(item.refId);
  }
}
